module.exports = __webpack_public_path__ + "img/heart.8c0fed6a.svg";